import React, { useContext } from "react";
import ReactImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Overlay } from "../../layout/Overlay";
import { Spinner } from "../../loader/Spinner";
import styles from "./Lightbox.scss";
import PropTypes from "prop-types";
import { AppContext } from "../../layout";

export const Lightbox = ({ images, activeIndex, caption, toolbar, onNext, onPrev, onClose }) => {
    const { containerRef } = useContext(AppContext);
    return activeIndex !== null && images?.length ? (
        <div className={styles.base}>
            <ReactImageLightbox
                wrapperClassName={styles.lightbox}
                mainSrc={images?.[activeIndex]}
                nextSrc={images?.length > 1 ? images[(activeIndex + 1) % images.length] : null}
                prevSrc={images?.length > 1 ? images[(activeIndex + images.length - 1) % images.length] : null}
                imageTitle={images?.length > 1 ? `${activeIndex + 1} / ${images?.length}` : null}
                imageCaption={caption}
                onMovePrevRequest={onPrev}
                onMoveNextRequest={onNext}
                onCloseRequest={onClose}
                toolbarButtons={toolbar}
                loader={
                    <div className={styles.loader}>
                        <Spinner color="contrast" />
                    </div>
                }
                reactModalStyle={{ zIndex: 10000 }}
                reactModalProps={{
                    parentSelector: () => containerRef?.current || document.body
                }}
            />
            <Overlay visible className={styles.overlay} />
        </div>
    ) : null;
};

Lightbox.propTypes = {
    /**
     * Array of image urls
     */
    images: PropTypes.array,
    /**
     * The index of the active image
     */
    activeIndex: PropTypes.oneOfType([PropTypes.number]),
    /**
     * Display caption under image
     */
    caption: PropTypes.any,
    /**
     * Add buttons to toolbar
     */
    toolbar: PropTypes.array,
    /**
     * Function to handle selecting next image
     */
    onNext: PropTypes.func,
    /**
     * Function to handling selecting previous image
     */
    onPrev: PropTypes.func,
    /**
     * Function to handle closing the lightbox
     */
    onClose: PropTypes.func
};
